module.exports = __webpack_public_path__ + "img/31b8e44.svg";